module.exports = __webpack_public_path__ + "static/pauloakenfold_3-696c7a566643d652dd3498ecfc7a1469.jpg";